import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BannerLarge from './_banner-large/component';
import BannerHero from './_banner-hero/component';
import BannerCover from './_banner-cover/component';
import BannerCoverflow from './_banner-coverflow/component';
import BannerResponsive from './_banner-responsive/component';
import BannerDisplay from './_banner-display/component';
import BannerSpread from './_banner-spread/component';
import BannerRibbon from './_banner-ribbon/component';
import BannerCollection from './_banner-collection/component';
import AnkeilerHighlight from '../sec_ankeiler/_ankeiler-highlight/component';
import BannerCampaign from './_banner-campaign/component';
import BannerSearch from './_banner-search/component';

import { promotionClickGoogleTag } from '@utils/analytics.js';

import './styles/styles.scss';

const transMap = {
  default: BannerHero,
  large: BannerLarge,
  hero: BannerHero,
  cover: BannerCover,
  coverflow: BannerCoverflow,
  responsive: BannerResponsive,
  campaign: BannerCampaign,
  display: BannerDisplay,
  spread: BannerSpread,
  ribbon: BannerRibbon,
  collection: BannerCollection,
  /**
   * The highlight ankeiler can be used as a banner,
   * so a background image can be passed as a prop
   * TODO: Add backgroundImage field for ankeilers in BO,
   *       so we can keep the seperation of ankeilers and banner
   */
  highlight: AnkeilerHighlight,
  search: BannerSearch,
};

class Banner extends Component {
  constructor(props) {
    super(props);
    this.googleTagMethods = this.googleTagMethods.bind(this);
    this.openSidePanel = this.openSidePanel.bind(this);
  }

  openSidePanel(e) {
    e.preventDefault();
    const { sidePanelLinkText, sidePanel } = this.props;
    this.props.store.modal.openModal('sidepanel', 'left', {
      title: sidePanelLinkText,
      component: <div className="banner-content">{sidePanel}</div>,
    });
  }

  get variant() {
    return this.props.variant || 'default';
  }

  getBannerVariant() {
    return transMap[this.variant] || transMap.default;
  }

  get pushToDataLayer() {
    return this.props.store.pushToDataLayer;
  }

  googleTagMethods() {
    return {
      pushPromotionGoogleTag: (promotion) => {
        this.pushToDataLayer(promotionClickGoogleTag(promotion));
      },
    };
  }

  render() {
    const BannerVariant = this.getBannerVariant();
    const { sidePanelLinkText } = this.props;
    return (
      <div className="banner-wrapper">
        <BannerVariant
          googleTagMethods={this.googleTagMethods}
          {...this.props}
        />
        {sidePanelLinkText && (
          <div className="side-panel-link" onClick={this.openSidePanel}>{sidePanelLinkText}</div>
        )}
      </div>
    );
  }
}
const availableVariants = Object.keys(transMap);

Banner.propTypes = {
  store: PropTypes.object,
  variant: PropTypes.oneOf(
    [
      ...availableVariants,
    ]
  ).isRequired,
  sidePanelLinkText: PropTypes.string,
  sidePanel: PropTypes.string,
};

export default Banner;
